import { takeLeading, call, fork } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { UserApi } from '~api/instances'

import { displayAPIError } from '~store/global/sagas'

import { fetchUser } from './actions'

export function* accountSagas() {
  yield fork(watchFetchUser)
}

/**
 * fetch user
 */
function* watchFetchUser() {
  yield takeLeading(fetchUser.started, function* () {
    try {
      yield call(fetchUserWorker)
    } catch (e) {
      yield displayAPIError(e, 'watchFetchUser')
    }
  })
}

const fetchUserWorker = bindAsyncAction(fetchUser, { skipStartedAction: true })(
  function* () {
    return yield call([UserApi, UserApi.getUser])
  },
)
